import config from 'config';

export const RECAPTCHA_KEY = config.recaptchaPublicKey || '';
export const RECAPTCHA_SRC = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`;

export const getRecaptchaToken = async () => {
  if (!RECAPTCHA_KEY) {
    return Promise.reject(new Error('Missing reCAPTCHA site key'));
  }

  // Please see https://developers.google.com/recaptcha/docs/loading for the reasoning for this
  // How this code snippet works:
  // This logic overwrites the default behavior of `grecaptcha.ready()` to
  // ensure that it can be safely called at any time. When `grecaptcha.ready()`
  // is called before reCAPTCHA is loaded, the callback function that is passed
  // by `grecaptcha.ready()` is enqueued for execution after reCAPTCHA is
  // loaded.
  if (typeof window.grecaptcha === 'undefined') {
    window.grecaptcha = {
      ready: cb => {
        const c = '___grecaptcha_cfg' as const;
        window[c] = window[c] || {};
        (window[c]['fns'] = window[c]['fns'] || []).push(cb);
      },
      execute: () => {
        return Promise.reject('grecaptcha not loaded');
      },
    };
  }

  return new Promise<string>((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      reject(new Error('reCAPTCHA failed to load'));
    }, 15000);

    window.grecaptcha.ready(() => {
      window.clearTimeout(timeout);
      window.grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(resolve).catch(reject);
    });
  });
};

// TODO: WPIP-75321 - This hook format is required due to CCL CompetitionsForm using it but ideally this logic would all sit in this file.
export const useGoogleReCaptcha = () => {
  const executeRecaptcha = async () => Promise.resolve();

  return { executeRecaptcha };
};
